import { render } from "./GiveItemsForm.vue?vue&type=template&id=5fbe3f26"
import script from "./GiveItemsForm.vue?vue&type=script&lang=js"
export * from "./GiveItemsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__